import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';
import { useState } from 'react';

type FieldDropdownProps = {
    value: any,
    options: Array<any>,
    id: string,
    label: any,
    onChange: (event: any, newInputValue: any, reason?:any) => void,
    disabled?: boolean
}

type FieldDropdownPropsVer2 = {
    value?: any,
    options: Array<any>,
    id: string,
    label: any,
    onChange: (event: any, newInputValue: any, reason: any) => void,
    loading?: boolean,
    select?: any,
    clear?: any,
    noOptionsText?: string,
    disabled?: boolean
}

const CssTextField = withStyles({
    root: {
        '& legend': {
            display: 'none',
        },
        '& label.Mui-focused': {
            color: 'white',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& input': {
                zIndex: '999'
            },
            '& fieldset': {
                borderColor: '#ccc',
            },
            '&:hover fieldset': {
                borderColor: '#ccc',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#ccc',
                borderWidth: '1px'
            },
        },
    },
})(TextField);

export const FieldDropdown = (props: FieldDropdownProps) => {
    
    return (
        <Autocomplete
            value={props.value}
            id={props.id}
            onInputChange={props.onChange}
            loadingText={"Carregando..."}
            options={props.options}
            getOptionLabel={props.label}
            renderInput={(params) => <CssTextField {...params} variant="outlined" />}
            disabled={props.disabled !== undefined ? props.disabled : false}
        />
    )
}

export const FieldDropdownVer2 = (props: FieldDropdownPropsVer2) => {

    return (
        <Autocomplete
            id={props.id}
            value={props.value !== undefined ? props.value : ""}
            onInputChange={props.onChange}
            loadingText={"Carregando..."}
            loading={props.loading}
            options={props.options}
            getOptionLabel={props.label}
            getOptionSelected={props.select}
            clearText={props.clear}
            noOptionsText={props.noOptionsText || "Digite uma opção válida"}
            renderInput={(params) => <CssTextField {...params} variant="outlined" />}
            disabled={props.disabled !== undefined ? props.disabled : false}
        />
    )
}